/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {finishInstantPayAutoAdvance} from '../api'

export const useMutationFinishInstantPayAutoAdvance = createReactQueryMutationHook('finishInstantPayAutoAdvance', finishInstantPayAutoAdvance)
